module.exports = __webpack_public_path__ + "img/arrowSvg.0ba47c96.svg";